import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useBrandsQuery from '../../hooks/useBrands';

import { useBrands } from '../../contexts/SiteContext';
import * as CardComponents from '../cards/brands';
import PresentationList, { PresentationListProps } from './PresentationList';

import styles from '../../styles/lists/brands-list.module.css';

const hooks = {
    default: useBrandsQuery,
};

export interface BrandsListProps extends Omit<
    PresentationListProps<Brand>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    excludeBrand?: string | null;
    query?: Record<string, unknown> | null;
    cardType?: string | null;
    cardComponent?: ElementType | null;
}

function BrandsList({
    excludeBrand = null,
    query = null,
    cardComponent = null,
    cardType = 'horizontal',
    className = null,
    hook = 'default',
    ...props
}: BrandsListProps) {
    const items = useBrands();
    const finalItems = [...(items || [])].filter(
        ({ handle }) => excludeBrand === null || handle !== excludeBrand,
    );

    return (
        <PresentationList<Brand>
            hook={
                query !== null ? (isString(hook) ? hooks[hook] || hooks.default : hook) : undefined
            }
            items={query === null ? finalItems : null}
            withoutLoader={query === null}
            query={query}
            paginated={false}
            placeholderCount={4}
            cardRatio={5 / 3}
            cardComponent={
                cardComponent || getComponentFromName(CardComponents, cardType, 'horizontal')
            }
            className={classNames([styles.container, className])}
            {...props}
        />
    );
}

export default BrandsList;
